export default __webpack_public_path__ + "static/media/cPlusPlus.24a8f938.png";